import Model from '@/models/Model'

export default class Comment extends Model {
    resource() {
        return 'pos_daily_cash'
    }

    getAcitveDailyCash(cashDeskId) {
        return new Promise((resolve, reject) =>
            this.include('g_user_opening_cashier.hr_employee')
                .where('pos_cash_desk_id', cashDeskId)
                .where('flag_open_daily_cash', true)
                .get()
                .then(
                    r =>
                        r.data && r.data.length
                            ? resolve(r.data[0])
                            : reject({
                                  response: {
                                      data: {
                                          message:
                                              'No se encontró apertura activa',
                                      },
                                  },
                              })
                )
                .catch(reject)
        )
    }
}
